// extracted by mini-css-extract-plugin
export default {"messageContainer":"FinalMessage_messageContainer__88gLg","fadeIn":"FinalMessage_fadeIn__Asj0g","letter":"FinalMessage_letter__C7Hk1","flipUp":"FinalMessage_flipUp__uBDEQ"};